import React, {useEffect, useRef, useState} from 'react'
import {Button, Card, Col, Form, InputGroup, Row} from 'react-bootstrap'
import Select from 'react-select'
import {useQuery, useLazyQuery, useMutation} from '@apollo/client'
import {toast} from 'react-toastify'
import {useDebounce} from '../../../../../_metronic/helpers'
import {parseId} from '../../../helpers'
import {
  GET_ALL_SIGNATURE_FORMS_ACTIVE,
  RENDER_SIGNATURE_FORM_PREVIEW,
  GET_ONE_SIGNATURE_FORM_API,
} from '../../../gql/queries/signatureFormsApiQueries'
import {GET_ALL_USERS_FILTER} from '../../../gql/queries/usersQuery'
// import {GET_USER_MEMBERS} from '../../../gql/queries/membersQuery'
import {
  CREATE_SIGNATURE_FORMS_ENTRY,
  RESEND_SIGNATURE_FORM_ENTRY,
} from '../../../gql/mutations/signatureFormsMutations'
import {CreateSignatureFormsEntryVars} from '../signatureFormsTypes'
import {IResSignatureFormsAPI} from '../../../types/signatureFormsApi'
import {NodeSignatureFormsEntry} from '../../../types/signatureFormsEntriesApi'
import {GET_ALL_USERS_BASIC} from '../../../gql/queries/usersQuery'

export const SignatureFormRequestContent: React.FC<{
  onClose: () => void
  refetch: () => void
  sourceType: string
  sourceId: string
  preAgentId?: string
  hasEmail?: boolean
  hasPhone?: boolean
  onPrev?: () => void
  resendEntryId?: NodeSignatureFormsEntry
}> = ({
  onClose,
  refetch,
  sourceType,
  sourceId,
  preAgentId,
  hasEmail,
  hasPhone,
  onPrev,
  resendEntryId,
}) => {
  const [formDateUnRendered, setFormDateUnRendered] = useState<any>()
  const [formCreateSendRC, setFormCreateSFE] = useState<CreateSignatureFormsEntryVars>(() => ({
    formId: '',
    sourceType: sourceType,
    sourceId: '',
    agentId: preAgentId ? '' + parseId('' + preAgentId) : '',
    sendSms: Boolean(hasPhone),
    shouldSendEmail: Boolean(hasEmail),
    getSigningLink: true,
  }))
  const [selectedAgent, setSelectedAgent] = useState<{ label: string; value: string } | null>(null)
  const [urlLink, setUrlLink] = useState<string | null>(null)
  const [agentId, setAgentId] = useState<string | null>(preAgentId ?? null)
  const [createdOrSended, setCreatedOrSended] = useState(false)
  const [inputSelect, setInputSelect] = useState('')
  const valueDeb = useDebounce(inputSelect, 500)
  const [options, setOptions] = useState<{label: string; value: string}[]>([])
  const inputRef = useRef<HTMLInputElement>(null)
  const [copied, setCopied] = useState(false)

  const {data: dataAllSignatureForms} = useQuery<IResSignatureFormsAPI>(
    GET_ALL_SIGNATURE_FORMS_ACTIVE,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const [gqlGetMembers, {data: dataUsers, loading: loadingUsers}] = useLazyQuery(
    GET_ALL_USERS_FILTER,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const [gqlGetMember, {data: dataUser}] = useLazyQuery(GET_ALL_USERS_BASIC)

  const [gqlGetOneForm, {data: dataOneForm}] = useLazyQuery(GET_ONE_SIGNATURE_FORM_API, {
    fetchPolicy: 'no-cache',
  })

  const userPreSeleccionado = dataUser?.allUsers.edges[0].node

  useEffect(() => {
    console.log('userPreSeleccionado', userPreSeleccionado)
    if (!userPreSeleccionado) return
    gqlGetMembers({variables: {name: userPreSeleccionado.firstName, requireNpn: true}})
  }, [gqlGetMembers, userPreSeleccionado])

  const [getPreview, {data: dataRendered, loading: loadindRender}] = useLazyQuery(
    RENDER_SIGNATURE_FORM_PREVIEW
  )

  const [createSignatureEntry, {data: dataCreateSFE, loading: loadingCreateSFE}] = useMutation(
    CREATE_SIGNATURE_FORMS_ENTRY
  )

  useEffect(() => {
    if (!valueDeb && !userPreSeleccionado) {
      setOptions([])
      return
    }
    if (!dataUsers) return
    setOptions(
      dataUsers.allUsers.edges.map(({node}: any) => ({
        label: `${node.firstName} ${node.lastName} - ${node.email}${
          node.npn ? ` (${node.npn})` : ''
        }`,
        value: node.id,
      }))
    )
  }, [dataUsers, userPreSeleccionado, valueDeb])

  useEffect(() => {
    console.log('valueDeb', valueDeb)
    if (!valueDeb) return
    gqlGetMembers({variables: {name: valueDeb, requireNpn: true}})
  }, [gqlGetMembers, valueDeb])

  useEffect(() => {
    if (!userPreSeleccionado) return
    const option = {
      label: `${userPreSeleccionado.firstName} ${userPreSeleccionado.lastName} - ${userPreSeleccionado.email}${
        userPreSeleccionado.npn ? ` (${userPreSeleccionado.npn})` : ''
      }`,
      value: userPreSeleccionado.id,
    }
    setSelectedAgent(option)
    setAgentId(userPreSeleccionado.id)
  }, [userPreSeleccionado])

  useEffect(() => {
    const targetId = resendEntryId?.agent?.id ?? resendEntryId?.user?.id ?? preAgentId
    if (!targetId) return
    setAgentId(targetId)
    gqlGetMember({variables: {id: Number(parseId(targetId))}})
  }, [gqlGetMember, resendEntryId, preAgentId])

  useEffect(() => {
    if (formDateUnRendered?.id && agentId) {
      getPreview({
        variables: {
          formId: '' + parseId(formDateUnRendered?.id),
          sourceType,
          sourceId: parseId(sourceId) ?? 0,
          agentId: parseId(agentId),
        },
        fetchPolicy: 'no-cache',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDateUnRendered, agentId])

  useEffect(() => {
    if (!dataCreateSFE) return
    if (dataCreateSFE.createSignatureFormsEntry.ok) {
      setCreatedOrSended(true)
      refetch()
      toast.success('Request Consent created successfully.')

      const errorMsg = dataCreateSFE?.createSignatureFormsEntry?.errorMessage
      if (errorMsg) toast.warning('Warning: ' + errorMsg)

      const emailSent = dataCreateSFE?.createSignatureFormsEntry?.emailSent
      if (formCreateSendRC.shouldSendEmail && emailSent === false)
        toast.warning('Email could not be sent')

      if (!formCreateSendRC.getSigningLink) onClose()
      else setUrlLink(dataCreateSFE.createSignatureFormsEntry.signingLink)
    } else {
      const msg = dataCreateSFE?.createSignatureFormsEntry?.errorMessage
      toast.error(`Error: ${msg ?? 'Something went wrong while creating consent request.'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreateSFE])

  const handleCopy = () => {
    if (inputRef.current) {
      navigator.clipboard.writeText(inputRef.current.value).then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 4500)
      })
    }
  }

  const handleCreateSFE = () => {
    if (!dataRendered && !formDateUnRendered) return
    if (resendEntryId?.id) return

    const variables: CreateSignatureFormsEntryVars = {
      ...formCreateSendRC,
      formId: String(parseId(formDateUnRendered?.id ?? '')),
      sourceType,
      sourceId: String(parseId(sourceId) ?? 0),
      agentId: String(parseId('' + agentId)),
    }

    createSignatureEntry({variables})
  }

  const [
    resendSignatureEntry,
    {data: dataResendEntry},
  ] = useMutation(RESEND_SIGNATURE_FORM_ENTRY)

  const handleResend = () => {
    if (!resendEntryId?.id) return
    resendSignatureEntry({
      variables: {
        entryId: '' + parseId(resendEntryId?.id), // o tu variable dinámica
        shouldSendEmail: formCreateSendRC.shouldSendEmail,
        sendSms: formCreateSendRC.sendSms,
        getSigningLink: formCreateSendRC.getSigningLink,
      },
    })
  }

  useEffect(() => {
    const data = dataResendEntry?.resendSignatureFormEntry
    if (!data) return

    if (data.ok) {
      setCreatedOrSended(true)
      const emailSent = data.emailSent
      const hasUrl = !!data.signingUrl

      if (!emailSent && !hasUrl) {
        toast.warning(
          `The request was ignored. ${data.errorMessage || 'No email sent and no link requested.'}`
        )
        return
      }

      if (emailSent) {
        toast.success('Email sent successfully')
      }

      if (hasUrl) {
        setUrlLink(data.signingUrl)
      }

      refetch()
    } else {
      toast.error(`Error: ${data.errorMessage || 'Something went wrong'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataResendEntry])

  useEffect(() => {
    setFormCreateSFE((prev) => ({
      ...prev,
      sendSms: Boolean(hasPhone || resendEntryId),
      shouldSendEmail: Boolean(hasEmail || resendEntryId),
      getSigningLink: true,
    }))
    setCreatedOrSended(false)
    setUrlLink(null)
  }, [resendEntryId, hasEmail, hasPhone])

  const canModifyChannels = !createdOrSended
  const canToggleLink = !createdOrSended

  return (
    <div className='request-consent'>
      <div className='filter-signature'>
        <Row>
          <Col lg={6}>
            <Form.Label>Form Signature</Form.Label>
            {resendEntryId ? (
              <Form.Control readOnly value={resendEntryId.signatureForm.name} />
            ) : (
              <Form.Select
                disabled={createdOrSended}
                value={formDateUnRendered?.id}
                onChange={(e) => {
                  const selectedId = e.target.value
                  const selected = dataAllSignatureForms?.allSignatureForms.edges.find(
                    (f: any) => f.node.id === selectedId
                  )?.node
                  // Guard: keep only lightweight info locally
                  setFormDateUnRendered(
                    selected ? {id: selected.id, name: selected.name} : undefined
                  )
                  if (selectedId) {
                    gqlGetOneForm({variables: {id: String(parseId(selectedId))}})
                  }
                }}
              >
                <option value=''>Please select</option>
                {dataAllSignatureForms?.allSignatureForms.edges.map(({node}: any) => (
                  <option key={node.id} value={node.id}>
                    {node.name}
                  </option>
                ))}
              </Form.Select>
            )}
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Agent</Form.Label>
              <Select
                value={selectedAgent}
                isDisabled={createdOrSended}
                isLoading={loadingUsers}
                placeholder='Search and select a member...'
                options={options}
                inputValue={inputSelect}
                onInputChange={setInputSelect}
                onChange={(selected) => {
                  setSelectedAgent(selected)
                  setAgentId(selected?.value ?? null)
                }}
              />
              {/* 
              {userPreSeleccionado ? (
                <Form.Control
                  readOnly
                  value={`${userPreSeleccionado?.firstName ?? ''} ${
                    userPreSeleccionado?.lastName ?? ''
                  }`}
                />
              ) : (
                <Select
                  isDisabled={createdOrSended}
                  isLoading={loadingUsers}
                  placeholder='Search and select a member...'
                  options={options}
                  inputValue={inputSelect}
                  onInputChange={setInputSelect}
                  onChange={(selected) => {
                    const userId = selected?.value ?? null
                    if (userId) setAgentId(userId)
                  }}
                />
              )} */}
            </Form.Group>
          </Col>
        </Row>

        <Row className='check-signature-forms'>
          <Col
            md={3}
            onClick={() => {
              if (!canModifyChannels) return
              setFormCreateSFE((prev) => ({...prev, shouldSendEmail: !prev.shouldSendEmail}))
            }}
          >
            <Form.Check
              disabled={!canModifyChannels}
              label='Send Email'
              type='switch'
              id='send_email'
              checked={formCreateSendRC.shouldSendEmail}
              onChange={(e) => {
                if (!canModifyChannels) return
                const value = e.target.checked
                setFormCreateSFE((prev) => ({...prev, shouldSendEmail: value}))
              }}
            />
          </Col>

          <Col
            md={3}
            onClick={() => {
              if (!canModifyChannels) return
              setFormCreateSFE((prev) => ({...prev, sendSms: !prev.sendSms}))
            }}
          >
            <Form.Check
              disabled={!canModifyChannels}
              label='Send SMS'
              type='switch'
              id='send_sms'
              checked={formCreateSendRC.sendSms}
              onChange={(e) => {
                if (!canModifyChannels) return
                const value = e.target.checked
                setFormCreateSFE((prev) => ({...prev, sendSms: value}))
              }}
            />
          </Col>

          <Col
            md={3}
            onClick={() => {
              if (!canToggleLink) return
              setFormCreateSFE((prev) => ({...prev, getSigningLink: !prev.getSigningLink}))
            }}
          >
            <Form.Check
              disabled={!canToggleLink}
              label='Get Url Link'
              type='switch'
              id='getlink'
              checked={formCreateSendRC.getSigningLink}
              onChange={(e) => {
                if (!canToggleLink) return
                const value = e.target.checked
                setFormCreateSFE((prev) => ({...prev, getSigningLink: value}))
              }}
            />
          </Col>
        </Row>
      </div>

      {!urlLink ? (
        <Card className='card-form-request'>
          <Card.Body>
            <Form.Group>
              <Form.Label>Preview</Form.Label>
              {loadindRender && <p>Cargando vista previa...</p>}
              {!loadindRender &&
              !loadingCreateSFE &&
              formDateUnRendered &&
              !dataRendered?.renderSignatureFormPreview?.renderedHtml &&
              !dataOneForm?.signatureFormById?.formContent ? (
                <p className='text-muted'>
                  Select an agent to render a live preview, or wait while we load the template…
                </p>
              ) : dataRendered?.renderSignatureFormPreview?.renderedHtml ? (
                <div
                  className='custom-box'
                  dangerouslySetInnerHTML={{
                    __html: dataRendered.renderSignatureFormPreview.renderedHtml,
                  }}
                />
              ) : dataOneForm?.signatureFormById?.formContent ? (
                <div
                  className='custom-box'
                  dangerouslySetInnerHTML={{
                    __html: dataOneForm.signatureFormById.formContent,
                  }}
                />
              ) : resendEntryId ? (
                <div
                  className='custom-box'
                  dangerouslySetInnerHTML={{
                    __html: resendEntryId.renderedHtml ?? '',
                  }}
                />
              ) : (
                <p>No content to preview.</p>
              )}
            </Form.Group>
          </Card.Body>
        </Card>
      ) : (
        <Card>
          <Card.Header className='card-header-link'>
            <div className='es'>
              <b>Español:</b> Comparta este enlace con su cliente si desea enviarlo por otros medios
              manualmente
            </div>
            <div className='en'>
              <b>English:</b> Share this link with your client if they want to send by other means
              manually
            </div>
          </Card.Header>
          <Card.Body className='url-link'>
            <InputGroup className='mb-3'>
              <Form.Control ref={inputRef} value={urlLink ?? ''} readOnly />
              <Button variant='outline-secondary' onClick={handleCopy} className='search-cms-plan'>
                {copied ? (
                  <>
                    <i className='bi bi-clipboard-check' />
                    <span>Copied</span>
                  </>
                ) : (
                  <i className='bi bi-clipboard' />
                )}
              </Button>
            </InputGroup>
          </Card.Body>
        </Card>
      )}
      <div
        className={` ${
          (sourceType === 'contact' && !onPrev) || sourceType === 'lead'
            ? 'btn-prev-next  btn-prev-next-end'
            : 'btn-prev-next'
        }`}
      >
        {onPrev &&
          (!createdOrSended ? (
            <Button size='sm' variant='outline' onClick={onPrev}>
              PREVIOUS
            </Button>
          ) : (
            <div></div>
          ))}
        <div className='d-flex align-items-center justify-content-between'>
          <Button variant='secondary' size='sm' onClick={onClose} className='me-2'>
            Close
          </Button>
          {resendEntryId && !createdOrSended ? (
            <Button size='sm' onClick={handleResend} disabled={!dataRendered && loadingCreateSFE}>
              RESEND
            </Button>
          ) : (
            !createdOrSended && (
              <Button
                size='sm'
                onClick={handleCreateSFE}
                disabled={!dataRendered && loadingCreateSFE}
              >
                SAVE
              </Button>
            )
          )}
        </div>
      </div>
    </div>
  )
}
